import PropTypes from 'prop-types'
import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  HeaderCell,
  Cell
} from '@table-library/react-table-library/table'
import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
  Button
} from '@material-tailwind/react'
import { useTheme } from '@table-library/react-table-library/theme'
import moment from '@/config/moment'
import { FiDownloadCloud } from 'react-icons/fi'
import { useEffect, useState } from 'react'
import { attachmentChipStatuses } from '@/constants/attachment-chip-statuses'
import ShowMoreText from 'react-show-more-text'
import { StatusChip } from '@/components/status-chip'
import { LoadingRow } from '@/shared/components/tables'
import { ATTACHMENT_STATUSES } from '@/constants'
import { createSearchParams } from 'react-router-dom'
import { tabOptions } from './constants'

export const AttachmentTableWithTabs = ({ getMore, initialSearchParams }) => {
  const defaultTab = tabOptions[0].key
  const [canFetchMore, setCanFetchMore] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [nodes, setNodes] = useState({ nodes: [] })
  const [currentTab, setCurrentTab] = useState(defaultTab)
  const lockedParams = {
    ...initialSearchParams,
    page: 1,
    per_page: 10
  }
  const [params, setParams] = useState(lockedParams)

  const getParamsByTab = ({ tabKey, params = {} }) => {
    const newParams = Object.assign({}, params)

    if (tabKey === 'restStatus') {
      newParams['status[]'] = [
        ATTACHMENT_STATUSES.pendingUpload,
        ATTACHMENT_STATUSES.rejected,
        ATTACHMENT_STATUSES.expired
      ]
    } else {
      newParams['status[]'] = tabKey
    }

    return newParams
  }

  const onTabChange = async (tabKey) => {
    try {
      setNodes({ nodes: [] })
      setParams(lockedParams)
      setCurrentTab(tabKey)
    } catch (error) {
      console.log('error', error)
    }
  }

  const loadMore = async () => {
    setIsLoading(true)
    try {
      const newSearchParams = createSearchParams(
        getParamsByTab({ tabKey: currentTab, params })
      )
      const { attachments, hasMore } = await getMore(newSearchParams)
      setNodes(
        {
          nodes: [...nodes.nodes, ...attachments]
        }
      )

      const newParams = {
        ...params,
        page: params.page + 1
      }

      setParams(newParams)
      setCanFetchMore(hasMore)
    } catch (error) {
      console.log('error', error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    console.log('currentTab', currentTab)
    loadMore()
  }, [currentTab])

  const theme = useTheme({
    Table: `
        --data-table-library_grid-template-columns: 3fr repeat(3, 1fr) 4fr 0.1fr;
      `
  })

  return (
    <Tabs value={currentTab}>
      <TabsHeader>
        {tabOptions.map(({ label, key }) => (
          <Tab key={key} value={key} onClickCapture={() => onTabChange(key)}>
            {label}
          </Tab>
        ))}
      </TabsHeader>
      <TabsBody>
        <TabPanel value={currentTab} className=''>
          <Table
            layout={{ custom: true }}
            theme={theme}
            data={nodes}
            className='max-h-80 mt-4 overflow-y'
          >
            {(tableList) => (
              <>
                <Header>
                  <HeaderRow>
                    <HeaderCell>Tipo</HeaderCell>
                    <HeaderCell>Periodo</HeaderCell>
                    <HeaderCell>Fecha de carga</HeaderCell>
                    <HeaderCell>Estado</HeaderCell>
                    <HeaderCell>Comentarios</HeaderCell>
                    <HeaderCell>Acciones</HeaderCell>
                  </HeaderRow>
                </Header>

                <Body>
                  {isLoading && <LoadingRow gridColumnEnd={7} />}
                  {!isLoading && !nodes.nodes.length && (
                    <Row >
                      <Cell className='flex flex-col' gridColumnStart={1} gridColumnEnd={7}>No hay información disponible</Cell>
                    </Row>
                  )}
                  {tableList.map(({ documentInfo, ...attachment }) => (
                    <Row key={attachment.id} item={attachment}>
                      <Cell>
                        <div className='text-wrap'>
                          {attachment.attachmentType.name}
                        </div>
                      </Cell>
                      <Cell>{attachment.period}</Cell>
                      <Cell>{moment(attachment.updatedAt).format('L')}</Cell>
                      <Cell>
                        <StatusChip
                          options={attachmentChipStatuses}
                          value={attachment.status}
                        />
                      </Cell>
                      <Cell class='px-1 py-1'>
                        <ShowMoreText
                          lines={2}
                          more={
                            <a className='underline underline-offset-2 text-blue-600'>
                              Ver más
                            </a>
                          }
                          less={
                            <a className='underline underline-offset-2 text-blue-600'>
                              Ver menos
                            </a>
                          }
                        >
                          {attachment?.comment?.body}
                        </ShowMoreText>
                      </Cell>
                      <Cell>
                        <a
                          href={documentInfo.url}
                          target='_blank'
                          rel='noreferrer'
                        >
                          <FiDownloadCloud />
                        </a>
                      </Cell>
                    </Row>
                  ))}
                  {
                    canFetchMore && (
                      <Row>
                        <Cell className='border-none flex flex-col' gridColumnStart={1} gridColumnEnd={7}>
                          <Button loading={isLoading} variant='outlined' color='white' onClick={loadMore}>Cargar más</Button>
                        </Cell>
                      </Row>
                    )
                  }
                </Body>
              </>
            )}
          </Table>
        </TabPanel>
      </TabsBody>
    </Tabs>
  )
}

AttachmentTableWithTabs.defaultProps = {
  attachments: [],
  isLoading: false
}

AttachmentTableWithTabs.propTypes = {
  attachments: PropTypes.arrayOf(PropTypes.object),
  getMore: PropTypes.func,
  initialSearchParams: PropTypes.object
}
